import React from "react";
import ClienteFormMobile from "./ClienteFormMobile";
import ClienteFormDesktop from "./ClienteFormDesktop";
import { useIsMobile } from "../../hooks/useDeviceType";

export default function ClienteForm({ cliente, cerrar, recargar }) {
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return <ClienteFormMobile cliente={cliente} cerrar={cerrar} recargar={recargar} />;
  }
  
  return <ClienteFormDesktop cliente={cliente} cerrar={cerrar} recargar={recargar} />;
}